import { render, staticRenderFns } from "./ComputerErased.vue?vue&type=template&id=4806bb39&"
import script from "./ComputerErased.vue?vue&type=script&lang=js&"
export * from "./ComputerErased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports